<template>
  <div>
    <div class="ab" :style="{ backgroundImage: 'url(' + bg + ')' }">
      <div class="ab-box">
        <div class="left">
          <h3 class="left-title reveal-bottom">
            {{ $t("ab.aboutUs") }}
          </h3>
          <p class="left-text reveal-bottom">
            {{ $t("ab.aboutUsCont") }}
          </p>
          <a
            href="#1"
            class="left-link reveal-bottom"
            :to="{ name: 'ContactUs' }"
            >{{ $t("ab.concatUs") }}</a
          >
        </div>
        <div
          class="right reveal-bottom"
          :style="{ backgroundImage: 'url(' + img + ')' }"
          @click="start"
        >
          <img
            class="video-img"
            :src="require('@/assets/img_svg/video_play_icon.svg')"
            alt="svg"
          />
        </div>
      </div>
    </div>
    <div class="ab-cont">
      <h3 class="reveal-bottom">{{ $t("ab.who") }}</h3>
      <p class="reveal-bottom">
        {{ $t("ab.whoCont") }}<br />
        {{ $t("ab.whoCont1") }}<br />
        {{ $t("ab.whoCont2") }}
      </p>
    </div>
    <div class="ab-flag reveal-bottom">
      <h1>Make Connection Easy, Make Business Agile.</h1>
    </div>
    <div>
      <h3 id="1" class="adr reveal-bottom">{{ $t("ab.locations") }}</h3>
      <div class="adr-wrap">
        <Card
          v-for="(item, index) in address"
          :key="index"
          :img="item.img"
          :cityName="$t(item.cityName)"
          :address="$t(item.address)"
          :other="item.other"
        />
      </div>
    </div>
    <Video ref="child" />
  </div>
</template>
<script>
import Video from "@/Pages/Home/Video";
import Card from "./Card";
import initAnimation from "../animation";
export default {
  data() {
    return {
      bg: require("@/assets/images/about-1-Overview-img-1.jpg"),
      img: require("@/assets/images/videoInit.png"),
      address: [
        {
          img: require("@/assets/images/about-1-Overview-img-2.jpg"),
          cityName: "ab.sz",
          address: "ab.szAdd",
          other: "contact@oceanbluecloud.com<br/>Tel:400-9966-550",
        },
        {
          img: require("@/assets/images/beijing.jpg"),
          cityName: "ab.bj",
          address: "ab.bjAdd",
          other: "contact@oceanbluecloud.com<br/>Tel:400-9966-550",
        },
        {
          img: require("@/assets/images/shanghai.jpg"),
          cityName: "ab.sh",
          address: "ab.shAdd",
          other: "contact@oceanbluecloud.com<br/>Tel: 021-31836988",
        },

        {
          img: require("@/assets/images/about-1-Overview-img-3.jpg"),
          cityName: "ab.hk",
          address: "ab.hkAdd",
          other: "contact@oceanbluecloud.com",
        },
        {
          img: require("@/assets/images/jinan.jpg"),
          cityName: "ab.jinan",
          address: "ab.jinanAdd",
          other: "contact@oceanbluecloud.com",
        },
        {
          img: require("@/assets/images/about-1-Overview-img-6.jpg"),
          cityName: "ab.singapore",
          address: "#10-09 PAYA LEBAR SQUARE SINGAPORE,",
          other: "contact@oceanbluecloud.com<br/>Tel: +0065 92343288",
        },
        {
          img: require("@/assets/images/about-1-Overview-img-5.jpg"),
          cityName: "ab.db",
          address:
            "Unit No 68, Ground floor, Bldg. No.17 Dubai Internet City, Dubai UAE PO BOX 336810",
          other: "contact@oceanbluecloud.com",
        },
        {
          img: require("@/assets/images/us.jpg"),
          cityName: "ab.us",
          address: "ab.usAdd",
          other: "contact@oceanbluecloud.com",
        },
        {
          img: require("@/assets/images/about-1-Overview-img-8.jpg"),
          cityName: "ab.flb",
          address: "ab.flbAdd",
          other: "contact@oceanbluecloud.com",
        },
        {
          img: require("@/assets/images/baxi.jpg"),
          cityName: "ab.bx",
          address: "ab.bxAdd",
          other: "contact@oceanbluecloud.com",
        },
      ],
    };
  },
  methods: {
    start() {
      this.$refs.child.start();
    },
  },
  components: {
    Video,
    Card,
  },
  mounted() {
    setTimeout(initAnimation, 0);
  },
};
</script>
<style scoped>
.ab {
  height: 600px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.ab-box {
  width: 1200px;
  height: 360px;
  margin: 159px auto 0;
  position: relative;
  padding: 0 10px;
  box-sizing: border-box;
}
.left {
  float: left;
}
.left-title {
  font-size: 44px;
  color: #000000;
  letter-spacing: 0;
  line-height: 66px;
}
.left-text {
  font-size: 22px;
  color: #000000;
  line-height: 34px;
  font-weight: bold;
  margin-top: 50px;
  width: 465px;
}
.right {
  float: right;
  width: 540px;
  height: 360px;
  position: relative;
  cursor: pointer;
}
.video-img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 40px;
}
.left-link {
  display: block;
  width: 200px;
  height: 50px;
  background: #00a3d1;
  font-size: 18px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: bold;
  line-height: 50px;
  position: absolute;
  left: 10px;
  bottom: 0;
}
.ab-cont {
  width: 1200px;
  margin: auto;
  overflow: hidden;
}
.ab-cont > h3 {
  font-size: 44px;
  color: #000000;
  letter-spacing: 0;
  text-align: center;
  line-height: 66px;
  margin: 180px auto 60px;
}
.ab-cont > p {
  font-size: 22px;
  color: rgba(0, 0, 0, 0.8);
  text-align: justify;
  line-height: 47px;
  margin-bottom: 200px;
}
.ab-flag {
  height: 300px;

  background: #00a3d1;
}
.ab-flag > h1 {
  width: 1200px;
  margin: auto;
  line-height: 300px;
  font-size: 44px;
  color: #ffffff;
  font-weight: bold;
}
.adr {
  font-size: 44px;
  color: #000000;
  letter-spacing: 0;
  text-align: center;
  font-weight: bold;
  margin: 143px auto 75px;
}
.adr-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 1200px;
  margin: 0 auto 74px;
}
</style>



// WEBPACK FOOTER //
// src/Pages/Overview/Overview.vue